import React, {useEffect, useState} from 'react';
import {
   Dimensions,
   Image,
   ImageBackground,
   Platform,
   SafeAreaView,
   StatusBar,
   StyleSheet,
   Text,
   TouchableOpacity,
   View,
} from 'react-native';
import Pulse from '../../utils/Pulse';
import {
   All,
   appBackground,
   gray,
   VALID,
   white,
   FONT_FAMILY_REGULAR,
   getFullName,
   getQRCode,
   getNorcatId,
   getProfileImage,
   primaryColor500,
   IBTRecords,
   isWeb,
   TrainingAllRecords,
} from '../../utils/utils';
import TabView from '../dashboard/TabView';
// import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import {MyTrainingPopup} from '../../utils/MyTrainingPopup';
import {PopoverLandscape} from '../../utils/popoverView';
import {useNavigation} from '@react-navigation/native';
import {
   getIsTabletPortrait,
   getShowLandscapeMsg,
   selectLandscapeSmallWebView,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
const topMargin = Platform.OS === 'ios' ? 85 : 60;

const ProfileHeader = props => {
   const navigation = useNavigation();
   const [selectedTrainingRecord, setSelectedTrainingRecord] =
      useState(TrainingAllRecords);
   const [selectedFilter, setSelectedFilter] = useState(VALID);
   const [anchorView, setAnchorView] = useState({x: 0, y: 100});
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const [popoverVisible, setPopoverVisible] = useState(false);
   const isIOS = Platform.OS === 'ios';
   const [validOrientationWeb, setValidOrientationWeb] = useState(true);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const showLandscapeMsg = useSelector(getShowLandscapeMsg);
   const isTabletPortraitMode = useSelector(getIsTabletPortrait);

   const handleLayout = event => {
      const {x, y, width, height} = event.nativeEvent.layout;
      setAnchorView({
         x: x,
         y: isIOS ? y + 120 : y + 100,
      });
   };

   useEffect(() => {
      if (isWeb) {
         setValidOrientationWeb(
            !(
               showLandscapeMsg &&
               (isLandscapeSmallWebView || isTabletPortraitMode)
            ),
         );
      }
   }, [isLandscapeSmallWebView, showLandscapeMsg, isTabletPortraitMode]);

   useEffect(() => {
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      Dimensions.addEventListener('change', handleResize);
      return () => {
         Dimensions.removeEventListener('change', handleResize);
      };
   }, []);

   return (
      <SafeAreaView style={styles.container}>
         <View
            style={[
               styles.headerTop,
               {
                  justifyContent: 'space-between',
                  paddingRight: props.title === 'My Training' ? 8 : 16,
               },
            ]}>
            {props.title === 'My Training' ? (
               <TouchableOpacity
                  onLayout={handleLayout}
                  onPress={evt => {
                     setPopoverVisible(true);
                  }}
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: primaryColor500,
                        paddingHorizontal: 10,
                        marginVertical: 4,
                        height: 34,
                        borderRadius: 4,
                     }}>
                     <Image
                        source={props.icon}
                        style={{width: 14, height: 14, tintColor: white}}
                     />
                     <Text
                        style={{
                           textAlignVertical: 'center',
                           color: white,
                           fontSize: 14,
                           marginLeft: 10,
                           fontWeight: '500',
                           fontFamily: FONT_FAMILY_REGULAR,
                        }}>
                        {selectedTrainingRecord}
                     </Text>

                     <Image
                        source={require('../../assets/down_arrow.png')}
                        style={{
                           marginStart: 10,
                           tintColor: white,
                           width: 24,
                           height: 18,
                           ...Platform.select({
                              web: {width: 24, height: 18},
                           }),
                        }}
                     />
                  </View>
               </TouchableOpacity>
            ) : (
               <View
                  style={{flexDirection: 'row', alignItems: 'center', flex: 1}}>
                  <Image
                     source={props.icon}
                     style={{width: 14, height: 14, tintColor: white}}
                  />
                  <Text
                     style={{
                        flex: 1,
                        textAlignVertical: 'center',
                        color: white,
                        fontSize: 14,
                        marginLeft: 10,
                        fontWeight: '500',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {props.title}
                  </Text>
               </View>
            )}
            {typeof props.onFilterClick !== 'undefined' ? (
               <View style={{flexDirection: 'row'}}>
                  <TouchableOpacity
                     onPress={() => {
                        setSelectedFilter(VALID);
                        props.onFilterClick(VALID);
                     }}>
                     <TabView
                        isSelected={selectedFilter === VALID ? true : false}
                        value="Valid"
                     />
                  </TouchableOpacity>
                  <TouchableOpacity
                     onPress={() => {
                        setSelectedFilter(All);
                        props.onFilterClick(All);
                     }}>
                     <TabView
                        isSelected={selectedFilter === All ? true : false}
                        value="All"
                     />
                  </TouchableOpacity>
               </View>
            ) : null}
         </View>
         <ImageBackground
            source={require('../../assets/profile_header_bg.png')}
            style={styles.headerTopBackground}>
            {/* <Svg
               height="200%"
               width="200%"
               style={StyleSheet.absoluteFillObject}>
               <Defs>
                  <LinearGradient id="grad" x1="0%" y1="100%" x2="0%" y2="0%">
                     <Stop offset="0%" stopColor="#003DA500" stopOpacity="0" />
                     <Stop offset="100%" stopColor="#001231" stopOpacity="1" />
                  </LinearGradient>
               </Defs>
               <Rect width="100%" height="100%" fill="url(#grad)" />
            </Svg> */}
            {/* <UISvg
               height={Platform.OS === 'web' ? '100%' : '200%'}
               width={Platform.OS === 'web' ? '100%' : '200%'}
               x1="0%"
               y1="100%"
               x2="0%"
               y2="0%"
               offset={['0%', '100%']}
               stopOpacity={['0', '1']}
               stopColor={['#003DA500', '#001231']}
            /> */}
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
               }}>
               <Image
                  source={
                     getProfileImage(props.authData) === 'NoPic'
                        ? require('../../assets/p_default.png')
                        : {
                             uri: `${getProfileImage(props.authData)}`,
                          }
                  }
                  style={{height: 72, width: 72, borderRadius: 36}}
               />
               <View
                  style={{
                     flexDirection: 'column',
                     marginLeft: 10,
                     flex: 1,
                     paddingEnd: 5,
                  }}>
                  <Text
                     ellipsizeMode="tail"
                     //numberOfLines={3}
                     style={{
                        color: white,
                        fontSize: 14,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        maxWidth: 200,
                        width: '100%',
                     }}>
                     {getFullName(props.authData)}
                  </Text>
                  <Text
                     style={{
                        color: white,
                        fontSize: 8,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginTop: 16,
                     }}>
                     NORCAT ID
                  </Text>
                  <Text
                     style={{
                        color: white,
                        width: '100%',
                        fontSize: 32,
                        marginTop: -5,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {getNorcatId(props.authData)}
                  </Text>
               </View>
            </View>
            <View style={{alignItems: 'center', justifyContent: 'center'}}>
               <Pulse />
               <TouchableOpacity
                  onPress={() => {
                     props.onQrClick();
                  }}>
                  <Image
                     source={{
                        uri:
                           'data:image/jpeg;base64,' +
                           getQRCode(props.authData), //props.authData.QRID,
                     }}
                     style={{height: 72, width: 72}}
                  />
               </TouchableOpacity>
            </View>
         </ImageBackground>
         <View style={styles.headerBottomBackground}>
            <Text
               style={{
                  flex: 1,
                  color: '#6E8EFF',
                  fontSize: 10,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {props.subTitle}
            </Text>
            {typeof props.isMyTraning !== 'undefined' ? (
               <Text
                  style={{
                     color: white,
                     fontSize: 10,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontStyle: 'italic',
                  }}>
                  {typeof props.trainigRecords === 'undefined'
                     ? '0' + ' Records'
                     : props.trainigRecords + ' Records'}
               </Text>
            ) : null}
         </View>
         {typeof props.isMyTraning !== 'undefined' ? (
            <View style={styles.headerBottomBackground2}>
               <Text
                  style={{
                     flex: 1,
                     color: gray,
                     fontSize: 10,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  Course Name
               </Text>
               <View
                  style={{
                     height: 12,
                     width: 1,
                     marginRight: 16,
                     backgroundColor: white,
                     opacity: 0.2,
                  }}
               />
               <Text
                  style={{
                     color: gray,
                     fontSize: 10,
                     fontWeight: '600',
                     marginRight: 10,
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  {selectedFilter === VALID ? 'Valid' : 'All'}
               </Text>
            </View>
         ) : null}

         {validOrientationWeb && (
            <PopoverLandscape
               visible={popoverVisible}
               anchorView={anchorView}
               onclose={() => {
                  setPopoverVisible(false);
               }}
               width={windowDimensions.width}
               height={windowDimensions.height}
               content={
                  <MyTrainingPopup
                     screen={navigation}
                     filterMytrainingData={filterText => {
                        setSelectedTrainingRecord(filterText);
                        props.filterMytrainingData(filterText);
                     }}
                     dismissPopover={() => {
                        setPopoverVisible(false);
                     }}
                  />
               }
            />
         )}
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: appBackground},
   headerTop: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      flexDirection: 'row',
      alignItems: 'center',
      height: 50,
   },
   headerTopBackground: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBackground: {
      backgroundColor: '#001231',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
   },
   headerBottomBackground: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBottomBackground2: {
      backgroundColor: '#000000',
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default ProfileHeader;
